<template lang="pug">
  b-tabs(v-model="activeTab" type="is-boxed" expanded)
    b-tab-item
      template(slot="header")
        b-icon(size="is-small" icon="file-code")
        span ecoSpold2
        |
        |
        b-icon(size="is-small" icon="arrow-right")
        |
        |
        b-icon(size="is-small" icon="file-excel")
        span Dataset Excel Template
      section.section
        eco-spold2-upload(@toUploadTab="activeTab = DATASET2SPOLD" @convertSpold2Template="convertSpold2Template")
    b-tab-item
      template(slot="header")
        b-icon(size="is-small" icon="file-excel")
        span Dataset Excel Template
        |
        |
        b-icon(size="is-small" icon="arrow-right")
        |
        |
        b-icon(size="is-small" icon="file-code")
        span ecoSpold2
      section.section
        template-upload(@toMasterDataTab="activeTab = MASTERDATA" @toSpoldTab="activeTab = SPOLD2EXCEL" @convertTemplate2Spold="convertTemplate2Spold")
    b-tab-item
      template(slot="header")
        b-icon(size="is-small" icon="file-alt")
        span User Master Data Validation
      section.section
        masterdata-validation(@toUploadTab="validationToUpload" @validateMasterdata="validateMasterdata")
</template>

<script>
import EcoSpold2Upload from './EcoSpold2Upload'
import TemplateUpload from './TemplateUpload'
import MasterdataValidation from './MasterdataValidation'

const SPOLD2EXCEL = 0
const DATASET2SPOLD = 1
const MASTERDATA = 2

export default {
  name: 'FileUpload',
  components: { MasterdataValidation, TemplateUpload, EcoSpold2Upload },
  data() {
    return {
      activeTab: null,
      SPOLD2EXCEL: SPOLD2EXCEL,
      DATASET2SPOLD: DATASET2SPOLD,
      MASTERDATA: MASTERDATA
    }
  },
  computed: {
  },
  methods: {
    validationToUpload(payload) {
      this.activeTab = DATASET2SPOLD
      console.log(payload)
    },
    convertSpold2Template(payload) {},
    convertTemplate2Spold(payload) {},
    validateMasterdata(payload) {}
  }
}
</script>

<style scoped>
  .section {
    padding: 1rem 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/FileUploads.vue